module.exports = __webpack_public_path__ + "static/img/fgbg1-13.04220d7.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/fgbg1-13.png
// module id = 191
// module chunks = 0